<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only"></span></a>
                <dl class="modal_content">
                    <dt class="ellipsis maintit">
                        <i>{{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}</i>
                    </dt>
                    <dd>
                        <div class="view_cont">
                            <dl class="view_subject">
                                <dt class="subject qna_view">
                                    <em class="textcolor_urgent" v-if="'Y' === question.urgentYn">
                                        [{{ $t('FIELD.GLOBAL.URGENT') }}]
                                    </em>
                                    {{ question.title }}
                                    <span class="in_date">{{ question.regDt }}</span>
                                </dt>
                            </dl>

                            <div class="view_question">
                                <dl class="dl_view" v-if="!isNull(question.ascAccount)">
                                    <dt>{{ $t('FIELD.USER.ACCOUNT.NO') }}</dt>
                                    <dd>{{ question.ascAccount }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.questionId)">
                                    <dt>{{ $t('FIELD.GLOBAL.QUESTION.ID') }}</dt>
                                    <dd>{{ question.questionId }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.inquiryTypeNm)">
                                    <dt>{{ $t('FIELD.GLOBAL.INQUIRY') }}</dt>
                                    <dd>{{ question.inquiryTypeNm }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.modelCd)">
                                    <dt>{{ $t('FIELD.GLOBAL.MODEL') }}</dt>
                                    <dd>{{ question.modelCd }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.prdCategoryNm)">
                                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                                    <dd>{{ question.prdCategoryNm }}</dd>
                                </dl>
                                <dl
                                    class="dl_view"
                                    v-if="!isNull(question.repairType) || !isNull(question.serialNumber)"
                                >
                                    <dt v-if="!isNull(question.repairType)">{{ $t('FIELD.QNA.REPAIR.TYPE') }}</dt>
                                    <dd v-if="!isNull(question.repairType)">{{ question.repairType }}</dd>
                                    <dt v-if="!isNull(question.serialNumber)">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</dt>
                                    <dd v-if="!isNull(question.serialNumber)">{{ question.serialNumber }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.partsNumber) || !isNull(question.partsName)">
                                    <dt v-if="!isNull(question.partsNumber)">
                                        {{ $t('FIELD.MYKNOWLEDGE.PARTS.NUMBER') }}
                                    </dt>
                                    <dd v-if="!isNull(question.partsNumber)">{{ question.partsNumber }}</dd>
                                    <dt v-if="!isNull(question.partsName)">{{ $t('FIELD.MYKNOWLEDGE.PARTS.NAME') }}</dt>
                                    <dd v-if="!isNull(question.partsName)">{{ question.partsName }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.svcOrder) || !isNull(question.mckImei)">
                                    <dt v-if="!isNull(question.svcOrder)">{{ $t('FIELD.QNA.SVC.ORDER') }}</dt>
                                    <dd v-if="!isNull(question.svcOrder)">{{ question.svcOrder }}</dd>
                                    <dt v-if="!isNull(question.mckImei)">{{ $t('FIELD.MYKNOWLEDGE.IMEI') }}</dt>
                                    <dd v-if="!isNull(question.mckImei)">{{ question.mckImei }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.requiredDt)">
                                    <dt>{{ $t('FIELD.GLOBAL.ANSWER.REQUIRED.DATE') }}</dt>
                                    <dd>{{ question.requiredDt }}</dd>
                                </dl>
                                <dl class="dl_view" v-if="!isNull(question.questionDesc)">
                                    <dt>{{ $t('FIELD.GLOBAL.QNA.DESC') }}</dt>
                                    <dd>
                                        <span v-html="stripHtml(question.questionDesc)"></span>
                                        <span class="in_btn_wrap">
                                            <a
                                                href="javascript:"
                                                class="btn_sm_white"
                                                @click="translationPop('question')"
                                            >
                                                {{ $t('FIELD.GLOBAL.TRANSLATION') }}
                                            </a>
                                        </span>
                                    </dd>
                                </dl>
                                <dl class="dl_view" v-if="0 < questionAttach.length && delay">
                                    <dt>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</dt>
                                    <dd>
                                        <innorix-download
                                            uploadId="question"
                                            :attachList="questionAttach"
                                            :serviceType="serviceType"
                                        />
                                    </dd>
                                </dl>
                                <dl class="attachment_link" v-if="questionAttach.length > 0">
                                    <span>
                                        <a href="javascript:" class="txt_link" @click="toggleLink($event)">
                                            Having trouble downloading?
                                        </a>
                                    </span>
                                    <dd>
                                        <ul>
                                            <li
                                                v-for="file in questionAttach"
                                                :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"
                                            >
                                                <a
                                                    href="javascript:"
                                                    @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                    class="txt_link"
                                                >
                                                    {{ file.FILE_NM }}
                                                </a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <!-- //reply -->
                                <dl
                                    class="commentWrite_wrap"
                                    v-if="
                                        ['ACP', 'PRO'].includes(result.FLOW_STATUS) &&
                                            loginNo === result.ANSWERER_USER_NO
                                    "
                                >
                                    <dt>
                                        {{ $t('MESSAGE.QNA.WANT') }} ({{ question.regUserNm }})
                                        {{ $t('MESSAGE.QNA.BEFORE') }}?
                                    </dt>
                                    <div class="view_qna_desc" v-if="'PRO' === result.FLOW_STATUS">
                                        <dl
                                            :class="'Y' === reply.ANSWERER_YN ? '' : 'reply'"
                                            v-for="reply in commentList"
                                            :key="pageName + reply.QUESTION_FLOW_ID + reply.COMMENT_SEQ"
                                        >
                                            <dt>
                                                <span class="item_status" v-if="'Y' === reply.ANSWERER_YN">
                                                    {{ $t('MESSAGE.QNA.EXP.ANS') }}
                                                </span>
                                                <span class="item_name">{{ reply.REG_USER_NAME }}</span>
                                                <span class="item_date">{{ reply.REG_DT }}</span>
                                            </dt>
                                            <dd>
                                                {{ reply.MESSAGE }}
                                                <span class="in_btn_wrap">
                                                    <a
                                                        href="javascript:"
                                                        class="btn_sm_white"
                                                        v-if="!isMobile()"
                                                        @click="translationPop(reply.MESSAGE)"
                                                    >
                                                        {{ $t('FIELD.GLOBAL.TRANSLATION') }}
                                                    </a>
                                                </span>
                                            </dd>
                                        </dl>
                                        <!-- reply -->
                                        <!-- class="reply_write_wrap reply" -->
                                        <dl class="reply_write_wrap" v-if="'PRO' === result.FLOW_STATUS">
                                            <dt data-input-type="textarea">
                                                <textarea
                                                    class="textarea_ty w100p"
                                                    maxlength="3000"
                                                    v-model="comment"
                                                ></textarea>
                                                <span class="textarea_counter">{{ commentLength }}/3000</span>
                                            </dt>
                                            <dd>
                                                <a
                                                    href="javascript:"
                                                    class="btn_reply"
                                                    @click="replyComment('replyComment')"
                                                >
                                                    {{ $t('BUTTON.MYKNOWLEDGE.REPLY') }}
                                                </a>
                                            </dd>
                                        </dl>
                                    </div>
                                    <dd data-input-type="textarea" v-if="'ACP' === result.FLOW_STATUS">
                                        <textarea
                                            class="textarea_ty w100p"
                                            maxlength="3000"
                                            v-model="comment"
                                        ></textarea>
                                        <span class="textarea_counter">{{ commentLength }}/3000</span>
                                    </dd>
                                    <dd class="btn" v-if="'ACP' === result.FLOW_STATUS">
                                        <a href="javascript:" class="btn_reply" @click="replyComment('firstComment')">
                                            {{ $t('BUTTON.GLOBAL.SEND') }}
                                        </a>
                                    </dd>
                                </dl>
                                <!-- //reply -->
                                <section
                                    class="answer_question_wrap"
                                    v-if="!['REG', 'WFA'].includes(result.FLOW_STATUS)"
                                >
                                    <p class="sec_title">
                                        <em>{{ $t('FIELD.GLOBAL.QNA.ANS') }}</em>
                                    </p>

                                    <dl class="dl_write">
                                        <dt>{{ $t('FIELD.GLOBAL.QNA.PRIVAT') }}</dt>
                                        <dd>
                                            <label class="checkbox-wrap">
                                                <input
                                                    type="checkbox"
                                                    v-model="openYn"
                                                    true-value="N"
                                                    false-value="Y"
                                                /><i class="check-icon"></i>
                                            </label>
                                        </dd>
                                    </dl>
                                    <dl class="dl_write">
                                        <dt>{{ $t('FIELD.FAST.ANSWER') }}</dt>
                                        <cross-editor
                                            :editorId="pageName"
                                            :editorData="stripHtml(nvl(proSolution.ANSDESC))"
                                        ></cross-editor>
                                    </dl>
                                    <dl class="dl_write">
                                        <dt>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</dt>
                                        <dd>
                                            <div class="attachment_wrap">
                                                <innorix-upload
                                                    uploadId="proSolution"
                                                    id="proSolution"
                                                    name="proSolution"
                                                    :serviceType="serviceType"
                                                    :onlyUpload="onlyUpload"
                                                    :attachList="proSolutionAttach"
                                                    @files="setFiles"
                                                />
                                            </div>
                                        </dd>
                                    </dl>
                                </section>
                            </div>
                            <!-- //See the Question -->
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_wrap_full topLine">
                            <div class="btn_right pc_only">
                                <a
                                    href="javascript:"
                                    class="btn_white"
                                    v-if="['ACP', 'PRO'].includes(result.FLOW_STATUS)"
                                    @click="save('Draft')"
                                >
                                    {{ $t('BUTTON.GLOBAL.SAVEDRAFT') }}
                                </a>
                                <a
                                    href="javascript:"
                                    class="btn_white"
                                    v-if="
                                        ['ANS', 'EVL', 'END', 'REQ'].includes(result.FLOW_STATUS) &&
                                            loginNo === proSolution.REGUSERNO
                                    "
                                    @click="save('Draft')"
                                >
                                    {{ $t('FIELD.GLOBAL.MODIFY') }}
                                </a>
                                <a
                                    href="javascript:"
                                    class="btn_white"
                                    v-if="['ACP', 'PRO'].includes(result.FLOW_STATUS) && '4' != deptLevelCd"
                                    @click="forward('U')"
                                >
                                    {{ $t('BUTTON.QNA.FORWARD.UP') }}
                                </a>
                                <a
                                    href="javascript:"
                                    class="btn_white"
                                    v-if="['ACP', 'PRO'].includes(result.FLOW_STATUS) && '1' != deptLevelCd"
                                    @click="forward('S')"
                                >
                                    {{ $t('BUTTON.QNA.FORWARD.TO') }}
                                </a>
                                <a
                                    href="javascript:"
                                    class="btn_blue"
                                    v-if="['ACP', 'PRO'].includes(result.FLOW_STATUS)"
                                    @click="save('save')"
                                >
                                    {{ $t('FIELD.FAST.ANSWER') }}
                                </a>
                                <a
                                    href="javascript:"
                                    class="btn_blue"
                                    v-if="['REG', 'WFA'].includes(result.FLOW_STATUS)"
                                    @click="acceptQuestion(question.questionId)"
                                >
                                    {{ $t('BUTTON.GLOBAL.ACCEPT') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, StringUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

import userListPopup from '~vb/faq/popup/userListPopup';
import commentPopup from '~vb/faq/popup/commentPopup';
import communicationPopup from '~vb/faq/popup/communicationPopup';
import forwardPopup from '~vb/faq/popup/forwardPopup';
import TransPopup from '~c/popup/TransPopup';
import CrossEditor from '~c/CrossEditor';
import InnorixDownload from '~c/InnorixDownload';
import InnorixUpload from '~c/InnorixUpload';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

require('moment-jdateformatparser');

export default {
    name: 'questionDetail',
    components: {
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
        'innorix-download': InnorixDownload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: {
        searchKey: '',
        rtnFunc: {
            type: Function,
        },
    },
    computed: {
        ...mapGetters({
            loginSystem: 'getLoginSystem',
            menus: 'getMenus',
            loginNo: 'getLoginNo',
            deptLevelCd: 'getDeptLevelCd',
        }),
        getQuestionId() {
            let questionId = (this.$route.query.questionId || '').trim();
            return questionId;
        },
        getReturnPage() {
            let page = (this.$route.query.page || '').trim();
            return page;
        },
    },
    data() {
        return {
            pageName: 'answerDetail',
            pageTitle: '',
            questionId: '',
            result: {},
            question: {},
            proSolution: {},
            flowSeq: '',
            flowStatus: '',
            questionAttach: [],
            proSolutionAttach: [],
            onlyUpload: false,
            serviceType: 'common',
            comment: '',
            commentLength: 0,
            commentList: [],
            openYn: 'N',
            isMobile: SDLUtil.isMobile,
            attachFileSeq: [],
            delAttachFiles: [],
            isRemove: false,
            delay: false,
        };
    },
    mounted() {
        EventBus.$on('question-detail-user-popup', param => {
            this.userListPopup(param);
        });
        EventBus.$on('question-detail-user-popup-comment', param => {
            this.commentPopup(param);
        });
        EventBus.$on('question-detail-user-popup-communication', param => {
            this.communicationPopup(param);
        });

        if (SDLUtil.isNull(this.searchKey)) {
            this.searchList(this.getQuestionId);
        } else {
            this.searchList(this.searchKey);
        }
    },
    watch: {
        comment() {
            this.commentLength = SDLUtil.textLength(this.comment);
        },
    },
    methods: {
        async searchList(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionDetailView.skp`,
                    qs.stringify({
                        systemId: this.loginSystem,
                        questionId: v,
                    }),
                )
                .then(resp => {
                    for (const result of resp.data.result.rowData) {
                        this.result = result;
                    }

                    this.question = resp.data.question;
                    this.questionAttach = resp.data.attach.rowData;

                    for (const solution of resp.data.proAnswer.rowData) {
                        this.proSolution = solution;
                    }

                    this.proSolutionAttach = resp.data.proAttach.rowData;

                    this.flowSeq = resp.data.flowSeq;
                    this.flowStatus = resp.data.flowStatus;

                    this.commentList = resp.data.commentList.rowData;

                    this.questionId = v;
                    if (SDLUtil.isNull(this.proSolutio)) {
                        this.openYn = 'N';
                    } else {
                        this.openYn = this.question.openYn;
                    }

                    SDLUtil.showLoadingBar(false);
                    setTimeout(() => {
                        this.getDelay();
                    }, 1000);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        getDelay() {
            this.delay = true;
        },
        menuCommit(menu, subMenu, connUrl) {
            for (const menus of this.menus) {
                if (menu === menus.menuNm) {
                    for (const menu of menus.subMenu) {
                        if (subMenu === menu.menuNm) {
                            store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                            if (SDLUtil.isNull(connUrl)) {
                                connUrl = menu.connUrl.replace('.skp', '');
                            }
                            return connUrl;
                        }
                    }
                }
            }
        },
        isNull(v) {
            return SDLUtil.isNull(v);
        },
        nvl(v) {
            return SDLUtil.nvl(v);
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        translationPop(v) {
            let translation = '';
            if ('question' === v) {
                translation = StringUtil.removeHtmlTag(this.stripHtml(this.question.questionDesc));
            } else if ('solution' === v) {
                translation = StringUtil.removeHtmlTag(this.stripHtml(this.proSolution.ANSDESC));
            } else {
                translation = v;
            }
            SDLUtil.show(
                TransPopup,
                {
                    bodyText: translation,
                },
                { height: 'auto' },
            );
        },
        acceptQuestion(v) {
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.ACCEPT.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/questionAccept.skp`,
                            qs.stringify({ questionId: this.questionId, questionFlowId: this.result.QUESTION_FLOW_ID }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            EventBus.$emit('question-snb-status');
                            return this.searchList(this.questionId);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        replyComment(v) {
            if (SDLUtil.isNull(this.comment)) return;
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/questionProcessing.skp`,
                    qs.stringify({
                        questionId: this.questionId,
                        questionFlowId: this.result.QUESTION_FLOW_ID,
                        comment: this.comment,
                        answererYn: 'Y',
                        replyComment: v,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    EventBus.$emit('question-snb-status');
                    this.searchList(this.questionId);
                    this.comment = '';
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // saveDraft() {
        //     SDLUtil.confirm({
        //         msg: SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM'),
        //         onOkEvt: () => {
        //             SDLUtil.showLoadingBar(true);
        //             return axios
        //                 .post(
        //                     `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/toAnswerSaveDraft.skp`,
        //                     qs.stringify({
        //                         questionId: this.questionId,
        //                         questionFlowId: this.result.QUESTION_FLOW_ID,
        //                         proAnsId: this.proSolution.ANSID,
        //                         ansDesc: window.answerDetail.GetValue('XHTML'),
        //                         openYn: this.openYn,
        //                         attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
        //                         delAttachFiles: this.delAttachFiles.map(item => item.attachFileSeq),
        //                         isRemove: this.isRemove,
        //                     }),
        //                 )
        //                 .then(resp => {
        //                     SDLUtil.showLoadingBar(false);
        //                     EventBus.$emit('question-snb-status');
        //                     return this.searchList(this.questionId);
        //                 })
        //                 .catch(err => {
        //                     Vue.$log.error(err);
        //                     SDLUtil.errorAlert(err);
        //                     SDLUtil.showLoadingBar(false);
        //                 });
        //         },
        //     });
        // },
        save(v) {
            let url = `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/toAnswerSave.skp`;
            if ('Draft' === v) {
                url = `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/toAnswerSaveDraft.skp`;
            }
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                questionId: this.questionId,
                                questionFlowId: this.result.QUESTION_FLOW_ID,
                                proAnsId: this.proSolution.ANSID,
                                ansDesc: window.answerDetail.GetBodyValue('XHTML'),
                                openYn: this.openYn,
                                attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
                                delAttachFiles: this.delAttachFiles.map(item => item.attachFileSeq),
                                isRemove: this.isRemove,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            EventBus.$emit('question-snb-status');
                            return this.searchList(this.questionId);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        pageMove(tab, v) {
            if ('createNewQuestion' === tab && !SDLUtil.isNull(v)) {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Create New Question', '/basis/qna/createNewQuestion'),
                    query: { questionId: SDLUtil.nvl(v) },
                });
            } else if ('reQuestion' === tab && !SDLUtil.isNull(v)) {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Create New Question', '/basis/qna/createNewQuestion'),
                    query: { preQuestionId: SDLUtil.nvl(v) },
                });
            } else if ('questionDetail' === tab && !SDLUtil.isNull(v)) {
                return this.$router.push({
                    path: this.menuCommit(
                        'Q&A',
                        'Answer Question',
                        '/skp/basis/myKnowledge/myQnA/myQuestion/questionDetail',
                    ),
                    query: { questionId: SDLUtil.nvl(v) },
                });
            } else {
                if ('Admin' === this.getReturnPage) {
                    return this.$router.push(
                        this.menuCommit('Admin', 'Q&A Status', '/skp/basis/admin/qnaManager/qnaStaus/qnaStatusList'),
                    );
                } else {
                    return this.$router.push(this.menuCommit('Q&A', 'Answer Question'));
                }
            }
        },
        menuCommit(menu, subMenu, connUrl) {
            for (const menus of this.menus) {
                if (menu === menus.menuNm) {
                    for (const menu of menus.subMenu) {
                        if (subMenu === menu.menuNm) {
                            store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                            if (SDLUtil.isNull(connUrl)) {
                                connUrl = menu.connUrl.replace('.skp', '');
                            }
                            return connUrl;
                        }
                    }
                }
            }
            if ('Admin' === this.getReturnPage) {
                return connUrl;
            }
        },
        userListPopup(param) {
            SDLUtil.show(
                userListPopup,
                {
                    param,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        commentPopup(param) {
            SDLUtil.show(
                commentPopup,
                {
                    param,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        communicationPopup(param) {
            SDLUtil.show(
                communicationPopup,
                {
                    param,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        forward(v) {
            SDLUtil.show(
                forwardPopup,
                {
                    question: this.question,
                    forward: v,
                    rtnFunc: () => {
                        // this.pageMove('questionList');
                        this.$emit('close');
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        setFiles(val) {
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
        getMessage(v) {
            if (!SDLUtil.isNull(v)) {
                v = v.replace(/\n/g, '<br />');
            }

            return v;
        },
        // 2020/08/05 김남갑 추가
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
    },
    beforeDestroy() {
        EventBus.$off('question-detail-user-popup');
        EventBus.$off('question-detail-user-popup-comment');
        EventBus.$off('question-detail-user-popup-communication');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/answerDetailPopup.vue